export default function initFacebookSDK () {
    if (window && window.FB) {
        window.FB.init({
            appId: '2561398784175766',
            xfbml: true,
            version: 'v11.0',
        })
        return true
    }
    return false
}